import styled, { css } from 'styled-components';
import { Link } from '@chegg-ui/link';
import { colors, font } from '@chegg-ui/theme';
var px12 = font.size.px12;
export var OrderManagementWrapper = styled.div.withConfig({
  componentId: "sc-1ytsnvi-0"
})(["padding-bottom:20px;"]);
export var StyledOrderManagementInfo = styled.p.withConfig({
  componentId: "sc-1ytsnvi-1"
})(["margin-block-start:1rem;margin-block-end:1rem;"]);
export var OrderManagementRow = styled.div.withConfig({
  componentId: "sc-1ytsnvi-2"
})(["display:flex;flex-direction:column;flex-wrap:wrap;"]);
export var TermsAndConditionsWrapper = styled.div.withConfig({
  componentId: "sc-1ytsnvi-3"
})(["padding-top:18px;width:100%;"]);
export var OrderManagementButtons = styled.div.withConfig({
  componentId: "sc-1ytsnvi-4"
})(["align-self:flex-end;margin-top:20px;width:100%;"]);
export var ButtonWrapper = styled.div.withConfig({
  componentId: "sc-1ytsnvi-5"
})(["display:flex;justify-content:flex-end;"]);
export var CancelButtonWrapper = styled.span.withConfig({
  componentId: "sc-1ytsnvi-6"
})(["margin:15px;cursor:pointer;"]);
export var BillingDetailsWrapper = styled.div.withConfig({
  componentId: "sc-1ytsnvi-7"
})(["padding:0 0 10px 0;font-family:", ";font-size:", ";line-height:", ";color:", ";"], font.family["default"], px12, font.lineHeight.sm, colors.dark);
export var LinkWithDisabledStyle = styled(Link).withConfig({
  componentId: "sc-1ytsnvi-8"
})(["", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "\n      opacity: 0.5;\n      cursor: default;\n      :hover {\n        text-decoration: none;\n      }\n      :active, :focus {\n        outline: 0;\n        border: none;\n        -moz-outline-style: none;\n      }\n    ";
});
export var PaddingContainer = styled.div.withConfig({
  componentId: "sc-1ytsnvi-9"
})(["", ""], function (_ref2) {
  var top = _ref2.top,
    right = _ref2.right,
    bottom = _ref2.bottom,
    left = _ref2.left,
    backgroundColor = _ref2.backgroundColor;
  return css(["padding:", "px ", "px ", "px ", "px;background-color:", ";"], top || 0, right || 0, bottom || 0, left || 0, backgroundColor);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OrderManagement/styled.js
// module id = 4713
// module chunks = 11